import App from "theme/base/App"
import "./theme.scss"

export default App


// WEBPACK FOOTER //
// ./src/theme/inware/App.js